export const convertDocumentType = (type: number & (1 | 2 | 3 | 4 | 5 | 6)) => {
    switch (type) {
        case 1: return 'Procedure'
        case 2: return 'Course'
        case 3: return 'Monograph'
        case 4: return 'Webinar'
        case 5: return 'Course'
        default: return 'type non definit'
    }
}